import { useQuery } from "@tanstack/react-query";
import { personService } from "../services/personService";

/** Lista de pessoas marcadas como Vendedor — para a carteira do cliente. */
export const useSalespeople = () => {
  const query = useQuery({
    queryKey: ["salespeople"],
    queryFn: () => personService.getVendedores(),
    staleTime: 5 * 60 * 1000,
  });

  return { salespeople: query.data ?? [], isLoading: query.isLoading };
};
